<template>
  <MallBottomSheet :handle="true" @close="$emit('close')">
    <div class="mall-product-purchase-sheet">
      <span class="typo-lg-semi">상품 구매하기</span>
      <div class="mall-product-purchase-sheet__contents">
        <span class="typo-body-m-medium mall-product-purchase-sheet__name">{{ product.name }}</span>
        <div class="mall-product-purchase-sheet__price-row">
          <span class="mall-product-purchase-sheet__price">{{ formatPrice(product.price) }}</span>
          <MallQuantityStepper
            :value="quantity"
            :max="product.maxCount || 999"
            :minusIcon="minusIcon"
            :plusIcon="plusIcon"
            @change="changeQuantity"
            @max-reached="$emit('max-reached', $event)"
          />
        </div>
        <div class="mall-product-purchase-sheet__divider"></div>
        <div class="mall-product-purchase-sheet__total">
          <span class="mall-product-purchase-sheet__total-label">총</span>
          <span class="mall-product-purchase-sheet__total-price">{{ formatPrice(totalPrice) }}</span>
        </div>
      </div>
    </div>

    <template slot="buttons">
      <MallButton :label="'장바구니 담기'" :type="'secondary'" @click="$emit('add-cart', quantity)" />
      <MallButton :label="'바로 구매하기'" :type="'primary'" @click="$emit('buy', quantity)" />
    </template>
  </MallBottomSheet>
</template>

<script>
import Constant from '@/constant'
import convert from '@/utilities/convert.js'
import mall from '@/utilities/mall.js'
import MallButton from '@/components/new/atoms/MallButton.vue'
import MallBottomSheet from '@/components/new/molecules/MallBottomSheet.vue'
import MallQuantityStepper from '@/components/new/molecules/MallQuantityStepper.vue'

export default {
  name: 'MallProductPurchaseSheet',
  components: {
    MallButton,
    MallBottomSheet,
    MallQuantityStepper,
  },
  props: {
    // { id, name, price, maxCount }
    product: {
      type: Object,
      required: true,
    },
    profileId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      quantity: 1,
      // 서버가 계산한 본인부담 금액 (계산 전 / 실패 시 null → 가격 × 수량)
      patientCost: null,
      costTimer: null,
      costRequestSeq: 0,
      // 구매 시트 디자인의 수량 아이콘
      minusIcon: require('@/assets/mall/icn_minus_line.svg'),
      plusIcon: require('@/assets/mall/icn_plus_line.svg'),
    }
  },
  computed: {
    totalPrice() {
      return this.patientCost !== null ? this.patientCost : this.product.price * this.quantity
    },
  },
  mounted() {
    this.fetchCost()
  },
  beforeDestroy() {
    clearTimeout(this.costTimer)
  },
  methods: {
    formatPrice(price) {
      return convert.setComma(price) + '원'
    },
    changeQuantity(quantity) {
      this.quantity = quantity
      this.patientCost = null
      // 진행 중인 이전 수량의 계산 결과는 버림
      this.costRequestSeq += 1
      // 수량을 연달아 바꿀 때는 마지막 값으로 한 번만 계산
      clearTimeout(this.costTimer)
      this.costTimer = setTimeout(() => this.fetchCost(), 300)
    },
    // 처방일수 / 경감 대상(구매정보)을 반영한 본인부담 금액
    fetchCost() {
      var token = mall.getAccessToken()
      if (!token || !this.profileId) return
      var info = mall.getPurchaseInfo(this.profileId)
      var seq = ++this.costRequestSeq
      this.$store.dispatch(Constant.CALC_STORE_COST, {
        cost: {
          profile_id: this.profileId,
          items: [{ product_id: this.product.id, quantity: this.quantity }],
          date_count: mall.getDateCount(info),
          recipient_type_code: mall.getRecipientTypeCode(info),
        },
        token: token,
      })
        .then((cost) => {
          // 늦게 도착한 이전 수량의 응답은 무시
          if (seq !== this.costRequestSeq) return
          this.patientCost = cost.patient_cost
        })
        .catch(() => {
          if (seq !== this.costRequestSeq) return
          this.patientCost = null
        })
    },
  },
}
</script>

<style scoped>
.mall-product-purchase-sheet {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mall-product-purchase-sheet__contents {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mall-product-purchase-sheet__name {
  color: #4E5968;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.mall-product-purchase-sheet__price-row {
  display: flex;
  padding: 12px 4px;
  align-items: center;
  gap: 4px;
}

.mall-product-purchase-sheet__price {
  flex: 1;
  min-width: 0;
  color: var(--color-text-main);
  font-family: Pretendard;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
}

.mall-product-purchase-sheet__divider {
  height: 1px;
  background: #E5E8EB;
}

.mall-product-purchase-sheet__total {
  display: flex;
  padding: 0 4px;
  justify-content: space-between;
  align-items: flex-start;
  font-family: Pretendard;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  white-space: nowrap;
}

.mall-product-purchase-sheet__total-label {
  color: #4E5968;
}

.mall-product-purchase-sheet__total-price {
  color: var(--color-text-main);
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallProductPurchaseSheet.vue